import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Menu,
  Bell,
  User,
  Settings,
  LogOut,
  ChevronDown,
  Globe,
  Moon,
  Sun,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useToast } from '../common/Toast';
import { ROUTES, USER_TYPES } from '../../constants/constants';
import config from '../../config/config';

const resolveImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  const base = config.apiBaseURL.replace(/\/api$/, '');
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
};

const Header = ({ onToggleSidebar, brandColors, isMobile = false }) => {
  const navigate = useNavigate();
  const { user, logout, getDisplayName, getCompanyName } = useAuth();
  const { t, currentLanguage, changeLanguage, getAvailableLanguages } = useLanguage();
  // const { theme, toggleTheme, isDark } = useTheme();
  const { success, error } = useToast();

  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const profileDropdownRef = useRef(null);
  const languageDropdownRef = useRef(null);
  const notificationsRef = useRef(null);
useEffect(() => {
  document.documentElement.classList.remove("dark");
  localStorage.setItem("theme", "light");
}, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setProfileDropdownOpen(false);
      }
      if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
        setLanguageDropdownOpen(false);
      }
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      // opponent_deadline clear karo portfolio page ka 
      sessionStorage.removeItem("opponent_deadline");
      localStorage.clear();
      await logout();
      success(t('auth.logoutSuccess'));
      // navigate(ROUTES.LOGIN);
          //  replace: true lagao taaki purana route history me na rahe
    navigate(ROUTES.LOGIN, { replace: true });

    } catch (err) {
      error(t('errors.genericError'));
    }
  };

  const handleLanguageChange = async (language) => {
    try {
      await changeLanguage(language);
      setLanguageDropdownOpen(false);
      success(t('profile.languageChanged'));
    } catch (err) {
      error(t('errors.genericError'));
    }
  };

  const displayName = getDisplayName();
  const companyName = getCompanyName();
  const availableLanguages = getAvailableLanguages();

  const notifications = [
    {
      id: 1,
      title: 'Search quota warning',
      message: 'You have used 80% of your monthly search quota',
      time: '2 hours ago',
      unread: true,
    },
    {
      id: 2,
      title: 'Report generated',
      message: 'Your trademark analysis report is ready',
      time: '1 day ago',
      unread: false,
    },
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
<header
  className="
    fixed top-0 right-0 h-16 z-30
    bg-white dark:bg-gray-900
    left-0 lg:left-72
  "
>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Left side */}
          <div className="flex items-center space-x-4">
            {/* Mobile menu button */}
            {isMobile && (
              <button
                type="button"
                className="p-2.5 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                onClick={onToggleSidebar}
                data-testid="mobile-menu-button"
              >
                <Menu className="h-6 w-6" />
              </button>
            )}

            {/* Company logo/name for mobile */}
            {isMobile && (
              <div className="ml-2">
                <h1 className="text-lg font-bold text-gray-900 dark:text-white">
                  {companyName || config.appNameShort}
                </h1>
              </div>
            )}

            {/* Desktop greeting */}
            {!isMobile && (
              <div className="flex items-center">
                <div className="text-sm">
                  <p className="text-xs text-gray-500 dark:text-gray-400">Welcome back</p>
                  <p className="font-semibold text-gray-900 dark:text-white">{displayName}</p>
                </div>
              </div>
            )}
          </div>
  {/* CENTER : LOGO */}
  <div className="flex justify-center flex-1">
    <img
      src="https://legallumo.com/assets/logo-package/logo/legal-lumo-logo-header.png"
      alt="Legal Lumo"
      className="h-8 object-contain"
    />
  </div>
          {/* Right side - Better aligned */}
          <div className="flex items-center space-x-1">
            {/* Theme Toggle Button - More Prominent */}
            {/* <button
              type="button"
              onClick={toggleTheme}
              className="relative p-2.5 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
              data-testid="theme-toggle-button"
              title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              <div className="relative w-5 h-5">
                {isDark ? (
                  <Sun className="h-5 w-5 text-yellow-500 dark:text-yellow-400 transition-transform duration-300 hover:rotate-90" />
                ) : (
                  <Moon className="h-5 w-5 text-indigo-600 dark:text-indigo-400 transition-transform duration-300 hover:-rotate-12" />
                )}
              </div>
            </button> */}

            {/* Language Selector */}
            {/* <div className="relative" ref={languageDropdownRef}>
              <button
                type="button"
                className="p-2.5 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                onClick={() => setLanguageDropdownOpen(!languageDropdownOpen)}
                data-testid="language-selector"
              >
                <Globe className="h-5 w-5" />
              </button>

              {languageDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-1 z-50 border border-gray-200 dark:border-gray-700 animate-fade-in">
                  {availableLanguages.map((lang) => (
                    <button
                      key={lang}
                      onClick={() => handleLanguageChange(lang)}
                      className={`block w-full text-left px-4 py-2.5 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${
                        currentLanguage === lang 
                          ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-medium' 
                          : 'text-gray-700 dark:text-gray-300'
                      }`}
                    >
                      {lang.toUpperCase()}
                    </button>
                  ))}
                </div>
              )}
            </div> */}

            {/* Notifications */}
            <div className="relative" ref={notificationsRef}>
              {/* <button
                type="button"
                className="p-2.5 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 relative"
                onClick={() => setNotificationsOpen(!notificationsOpen)}
                data-testid="notifications-button"
              >
                <Bell className="h-5 w-5" />
                {unreadCount > 0 && (
                  <span className="absolute top-1 right-1 h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center animate-pulse font-semibold">
                    {unreadCount}
                  </span>
                )}
              </button> */}

              {notificationsOpen && (
                <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-xl py-1 z-50 border border-gray-200 dark:border-gray-700 animate-fade-in">
                  <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                    <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                      {t('common.notifications')}
                    </h3>
                  </div>

                  <div className="max-h-64 overflow-y-auto custom-scrollbar">
                    {notifications.length > 0 ? (
                      notifications.map((notification) => (
                        <div
                          key={notification.id}
                          className={`px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer ${
                            notification.unread ? 'bg-blue-50 dark:bg-blue-900/20' : ''
                          }`}
                        >
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <p className="text-sm font-medium text-gray-900 dark:text-white">
                                {notification.title}
                              </p>
                              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                {notification.message}
                              </p>
                              <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                                {notification.time}
                              </p>
                            </div>
                            {notification.unread && (
                              <div className="ml-2 w-2 h-2 bg-blue-500 rounded-full"></div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                        <p className="text-sm">{t('common.noNotifications')}</p>
                      </div>
                    )}
                  </div>

                  {notifications.length > 0 && (
                    <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700">
                      <button className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300 font-medium transition-colors">
                        {t('common.viewAll')}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Divider */}
            <div className="h-6 w-px bg-gray-300 dark:bg-gray-700 mx-2"></div>

            {/* Profile dropdown */}
            <div className="relative" ref={profileDropdownRef}>
              <button
                type="button"
                className="flex items-center space-x-2 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 p-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
                data-testid="profile-button"
              >
                {user?.profile_image ? (
                  <img
                    className="h-9 w-9 rounded-lg object-cover ring-2 ring-gray-200 dark:ring-gray-700"
                    src={resolveImageUrl(
                      user.profile_image_url || user.profile_image
                    )}
                    alt={displayName}
                  />
                ) : (
                  <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center ring-2 ring-gray-200 dark:ring-gray-700">
                    <span className="text-white font-semibold text-sm">
                      {displayName?.charAt(0) || 'U'}
                    </span>
                  </div>
                )}

                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">{displayName}</p>
                  {companyName && (
                    <p className="text-xs text-gray-500 dark:text-gray-400">{companyName}</p>
                  )}
                </div>

                <ChevronDown className="h-4 w-4 text-gray-400 dark:text-gray-500" />
              </button>

              {profileDropdownOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-xl py-1 z-50 border border-gray-200 dark:border-gray-700 animate-fade-in">
                  <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                    <p className="text-sm font-medium text-gray-900 dark:text-white">{displayName}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{user?.email}</p>
                    {companyName && (
                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{companyName}</p>
                    )}
                  </div>

                  <Link
                    to={ROUTES.PROFILE}
                    className="flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    <User className="mr-3 h-4 w-4" />
                    {t('nav.profile')}
                  </Link>

                  {user.userType == USER_TYPES.CLIENT && (
                    <Link
                      to={ROUTES.PREFERENCES}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                      onClick={() => setProfileDropdownOpen(false)}
                    >
                      <Settings className="mr-3 h-4 w-4" />
                      {t('nav.preferences')}
                    </Link>
                  )}

                  <div className="border-t border-gray-200 dark:border-gray-700 my-1"></div>

                  <button
                    onClick={handleLogout}
                    className="flex items-center w-full px-4 py-2.5 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
                  >
                    <LogOut className="mr-3 h-4 w-4" />
                    {t('auth.signOut')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;